exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-shared-secondary-menu-styles-___submenu-title__leftMenuTitleContainer___2BJkf{background-color:#e0e0e0;text-transform:capitalize;border-bottom:1px solid #252525;padding:10px 10px 10px 15px;cursor:pointer;font-family:Lato,Arial;color:#252525}.src-components-shared-secondary-menu-styles-___submenu-title__titleArrow___2sJnO{font-size:20px;line-height:20px;color:#252525}", ""]);

// exports
exports.locals = {
	"leftMenuTitleContainer": "src-components-shared-secondary-menu-styles-___submenu-title__leftMenuTitleContainer___2BJkf",
	"titleArrow": "src-components-shared-secondary-menu-styles-___submenu-title__titleArrow___2sJnO"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/shared/secondary-menu/styles/submenu-title.scss
 ** module id = 901
 ** module chunks = 0
 **/